import { render, staticRenderFns } from "./SpotPriceChart.vue?vue&type=template&id=32c54936&"
import script from "./SpotPriceChart.vue?vue&type=script&lang=js&"
export * from "./SpotPriceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports